export const canonicalFinancialOrder = [
  "physicals",
  "ampliDisbursement",
  "cashProjection",
  "disbursement",
  "disbWithAdvance",
  "measuredMonthly",
  "paid",
  "toPay",
];

export const orderFinancialSeries = (
  configured = [],
  { hasPrevision = false } = {},
) => {
  const unique = [...new Set(Array.isArray(configured) ? configured : [])]
    .filter((key) => key !== "measuredMonthly" || hasPrevision);
  if (hasPrevision && !unique.includes("measuredMonthly")) {
    unique.push("measuredMonthly");
  }
  const configuredSet = new Set(unique);
  return [
    ...canonicalFinancialOrder.filter((key) => configuredSet.has(key)),
    ...unique.filter((key) => !canonicalFinancialOrder.includes(key)),
  ];
};
